import React from 'react'
import Button from 'app/components/ButtonDefault'
import cn from 'classnames'

import './styles.scss'
import { IIconButtonProps } from './interface'

const bc = 'icon-button'

export const IconButton: React.FC<IIconButtonProps> = ({
  children,
  className,
  disabled = false,
  selected,
  secondary,
  title,
  ...rest
}) => (
  <Button
    xs
    disabled={disabled}
    className={cn(
      bc,
      {
        [`${bc}--selected`]: selected,
        [`${bc}--secondary`]: secondary,
      },
      className
    )}
    title={title}
    {...rest}
  >
    <div className={`${bc}__icon-wrapper`}>{children}</div>
  </Button>
)

export default IconButton
